import React from 'react'
import { Button, Form, Input, Radio } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx

import { validatLength, validatLength2, validatePhone } from '@/utils/check'

const SystemInput = ({ title }) => {
  const { SystemStore } = useStore()

  // 取消按钮
  const [form] = Form.useForm()


  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      await SystemStore.getAddButtom(values)
    } else if (title === '编辑') {
      await SystemStore.getPutInformation(values)
    }
    runInAction(() => {
      set(SystemStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{
            xtzt: 1
          }}
        >
          <Form.Item label="系统编号" name="xtbh" rules={[
            {
              required: true,
              message: '请输入系统编号',
            },
            {
              validator: validatLength
            },
          ]}>
            <Input placeholder="请输入系统编号" />
          </Form.Item>
          <Form.Item label="系统名称" name="xtmc" rules={[
            {
              required: true,
              message: '请输入系统名称',
            },
            {
              validator: validatLength2
            },
          ]}>
            <Input placeholder="请输入系统名称" />
          </Form.Item>
          <Form.Item label="系统IP" name="xtip" rules={[
            {
              required: true,
              message: '请输入系统IP',
            },
            {
              validator: validatLength
            },
          ]}>
            <Input placeholder="请输入系统IP" />
          </Form.Item>
          <Form.Item label="系统状态" name="xtzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="联系人" name="xtlxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            },
          ]}>
            <Input placeholder="请输入联系人" />
          </Form.Item>
          <Form.Item label="联系电话" name="xtlxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入联系电话" />
          </Form.Item>

          <Form.Item label="备注" name="bz" rules={[
            {
              required: true,
              message: '请输入备注',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(SystemStore.valueData)}
        >
          <Form.Item label="系统编号" name="xtbh" rules={[
            {
              required: true,
              message: '请输入系统编号',
            },
            {
              validator: validatLength
            },
          ]}>
            <Input placeholder="请输入系统编号" />
          </Form.Item>
          <Form.Item label="系统名称" name="xtmc" rules={[
            {
              required: true,
              message: '请输入系统名称',
            },
            {
              validator: validatLength2
            },
          ]}>
            <Input placeholder="请输入系统名称" />
          </Form.Item>

          <Form.Item label="系统IP" name="xtip" rules={[
            {
              required: true,
              message: '请输入系统IP',
            },
            {
              validator: validatLength
            },
          ]}>
            <Input placeholder="请输入系统IP" />
          </Form.Item>
          <Form.Item label="系统状态" name="xtzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            },
            {
              validator: validatLength
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="联系人" name="xtlxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入联系人" />
          </Form.Item>
          <Form.Item label="联系电话" name="xtlxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入联系电话" />
          </Form.Item>

          <Form.Item label="备注" name="bz" rules={[
            {
              required: true,
              message: '请输入备注',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '查看' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(SystemStore.valueData)}
        >
          <Form.Item label="系统编号" >
            {SystemStore.valueData.xtbh}
          </Form.Item>
          <Form.Item label="系统名称">
            {SystemStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="系统IP">
            {SystemStore.valueData.xtip}
          </Form.Item>
          <Form.Item label="系统状态">
            {SystemStore.valueData.xtzt === 1 ? '启用' : '禁用'}
          </Form.Item>
          <Form.Item label="联系人">
            {SystemStore.valueData.xtlxr}
          </Form.Item>
          <Form.Item label="联系电话">
            {SystemStore.valueData.xtlxdh}
          </Form.Item>

          <Form.Item label="备注">
            {SystemStore.valueData.bz}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(SystemInput)